import dateFormat from 'dateformat';
import React, {useEffect, useState} from 'react';
import Pagination from '../../DetailsPage/Pagination/Pagination';
import * as S from './ImageGalleryPopup.styles';

interface IImageGalleryPopupType {
  data: Array<object>;
  getMoreData?: Function;
  totalCount: number;
  typeOfPopup?: string;
  changeTypeOfGalleryPopup?: Function;
  isUserReview?: boolean;
  travellerTab?: boolean;
  hotellierTab?: boolean;
  safetyTab?: boolean;

  reviewInfo?: object;
  initialPage?: number;
  styleProps?: {
    [k: string]: string | number;
  }; // css props
}

const ImageGalleryPopup = ({
  data,
  getMoreData,
  totalCount,
  typeOfPopup,
  changeTypeOfGalleryPopup,
  isUserReview = false,
  travellerTab = false,
  hotellierTab = false,
  safetyTab = false,
  reviewInfo = {},
  initialPage = 1,
  styleProps = {},
}: IImageGalleryPopupType) => {
  const [status, updateStatus] = useState(['default']);
  const [currentImageData, updateCurrentImageData] = useState({currentImage: '', currentTag: ''});
  const [setPrevNext, updateSetPrevNext] = useState({onPrevNext: () => {}});
  const [currentPage, updateCurPage] = useState(1);
  const [totalImgCount, updateTotalImgCount] = useState(totalCount);
  const [paginatorConfig, updatePaginatorConfig] = useState();
  const [thumbnailDataList, updateThumbnailDataList] = useState([]);
  const [countAvailable, updatecountAvailable] = useState(data.length);
  const {firstName = '', lastName = '', submittedAt = '', reviewContent = ''} = reviewInfo;

  useEffect(() => {
    updateTotalImgCount(totalCount);
  }, [totalCount]);

  useEffect(() => {
    updateStatus(status);
  }, [status]);

  useEffect(() => {
    updatecountAvailable(data.length);
  }, [data]);

  const getPageVolume = pageNumber => {
    let pageVol = 1;
    return pageVol;
  };

  const ThumbnailComponent = ({sourceImg}) => {
    return (
      <S.ImageItemWrapperStyle>
        <S.ImageItemStyle src={sourceImg} />
      </S.ImageItemWrapperStyle>
    );
  };

  const initialCallback = ({onPrevNext}) => {
    updateSetPrevNext({onPrevNext: onPrevNext});
  };

  const {width} = styleProps;

  const getParsedReview = text => {
    let openTag = '<b>',
      closeTag = '</b>';
    const comp = [];
    if (!text || text === null || text === 'null') {
      return null;
    }
    const splitArray = text.split(openTag);
    if (splitArray[0].indexOf(closeTag) === -1) {
      if (splitArray[0]) {
        comp.push(<S.UserReviewTextStyle>{splitArray[0]}</S.UserReviewTextStyle>);
      }
      splitArray.shift();
    }

    splitArray.forEach(txt => {
      const secondSplit = txt.split(closeTag);
      if (secondSplit[0]) {
        comp.push(
          <S.UserReviewTextStyle className="active">{secondSplit[0]}</S.UserReviewTextStyle>,
        );
      }
      if (secondSplit[1]) {
        comp.push(<S.UserReviewTextStyle>{secondSplit[1]}</S.UserReviewTextStyle>);
      }
    });
    if (!comp.length) {
      return null;
    }
    return <S.UserReviewTextStyle>{comp}</S.UserReviewTextStyle>;
  };

  useEffect(() => {
    onPageChangeHandler();
  }, [paginatorConfig]);

  const onPageChangeHandler = () => {
    if (!paginatorConfig) {
      return null;
    }

    let pageLength = paginatorConfig.pages.length;
    let dataList = data.slice(paginatorConfig.pages[0] - 1, paginatorConfig.pages[pageLength - 1]);

    //thumbnails data list
    let dataListToRender = dataList.map(item => item.m);

    //setting thubmnail data list
    updateThumbnailDataList(dataListToRender);

    //preloading thumbnail images
    dataListToRender.map(item => {
      let img = new Image();
      img.src = item;
    });

    //preloading some data as per requirement
    dataList.map(dataImg => {
      var img = new Image();
      img.src = dataImg.b;
    });

    //actual data to display
    let dataToRender = data.slice(
      paginatorConfig.offset,
      paginatorConfig.offset + paginatorConfig.limit,
    );

    if (dataToRender.length !== 0) {
      updateCurrentImageData({currentImage: dataToRender[0].b, currentTag: dataToRender[0].tag});
      updateCurPage(paginatorConfig.currentPage);
    }
    // ajax calls for more data
    if (
      currentPage >= countAvailable / 2 &&
      countAvailable < totalImgCount &&
      totalImgCount > 10 &&
      typeOfPopup !== 'goSafe'
    ) {
      getMoreData && getMoreData(countAvailable - 10);
    } else if (
      typeOfPopup === 'goSafe' &&
      (currentPage >= countAvailable / 2 || currentPage === countAvailable - 2) &&
      countAvailable < totalImgCount
    ) {
      getMoreData && getMoreData();
    }
  };

  const onChangePage = ({offset, limit, pages, currentPage}) => {
    updatePaginatorConfig({
      offset: offset,
      limit: limit,
      pages: pages,
      currentPage: currentPage,
    });
  };

  // For Left and Right key support
  document.onkeydown = handleKeyDown;

  function handleKeyDown(e) {
    //left arrow support
    if (e.keyCode === 37 && currentPage !== 1) {
      setPrevNext.onPrevNext({e, page: currentPage - 1});
    }
    //right arrow support
    else if (e.keyCode === 39 && currentPage !== totalImgCount) {
      setPrevNext.onPrevNext({e, page: currentPage + 1});
    }
  }

  return (
    <S.OuterContainerGallery>
      <S.ContentTextOuterWrap>
        <S.ContentWrapperStyle width={width}>
          <div>
            <S.PhotoTypeTabUl>
              {hotellierTab && (
                <li
                  className={
                    typeOfPopup === 'hotellier' || typeOfPopup === 'captivate' ? 'active' : ''
                  }
                  onClick={() => changeTypeOfGalleryPopup('hotellier')}
                >
                  <span>Hotelier Photos</span>
                </li>
              )}
              {travellerTab && (
                <li
                  className={typeOfPopup === 'traveller' ? 'active' : ''}
                  onClick={() => changeTypeOfGalleryPopup('traveller')}
                >
                  <span>Traveller Photos</span>
                </li>
              )}
              {safetyTab && (
                <li
                  className={typeOfPopup === 'goSafe' ? 'active' : ''}
                  onClick={() => changeTypeOfGalleryPopup('goSafe')}
                >
                  <span>Safety and Hygiene</span>
                </li>
              )}
            </S.PhotoTypeTabUl>
          </div>

          <S.MainImageWrapperStyle>
            <S.MainImageWrapper>
              <S.LoaderImage src="https://gos3.ibcdn.com/loader-1579008209.gif" />
            </S.MainImageWrapper>
            {currentImageData.currentImage && (
              <S.MainImageStyle src={currentImageData.currentImage} />
            )}
            {currentImageData.currentTag && (
              <S.RoomLabelWrapperStyle>
                <S.RoomLabelTextStyle>{currentImageData.currentTag}</S.RoomLabelTextStyle>
              </S.RoomLabelWrapperStyle>
            )}

            {currentPage !== 1 ? (
              <S.LeftIconWrapperStyle
                onClick={() => setPrevNext.onPrevNext({page: currentPage - 1})}
              >
                <S.ArrowIconWrapperStyle>
                  <S.LeftArrowGalleryTraveller />
                </S.ArrowIconWrapperStyle>
              </S.LeftIconWrapperStyle>
            ) : (
              ''
            )}

            {currentPage < totalImgCount ? (
              <S.RightIconWrapperStyle
                onClick={() => setPrevNext.onPrevNext({page: currentPage + 1})}
              >
                <S.ArrowIconWrapperStyle>
                  <S.RightArrowGalleryTraveller />
                </S.ArrowIconWrapperStyle>
              </S.RightIconWrapperStyle>
            ) : (
              ''
            )}
          </S.MainImageWrapperStyle>
          <S.ImageListWrapperStyle>
            <S.ImageGalleryUl>
              {totalImgCount > 0 && data && (
                <Pagination
                  onChangePage={onChangePage}
                  initialPage={initialPage}
                  getPageSize={getPageVolume}
                  totalNumberOfItems={totalImgCount}
                  status={status}
                  initCall={true}
                  maxPages={7}
                  ThumbnailComponent={ThumbnailComponent}
                  initialCallback={initialCallback}
                  type={'thumbnail'}
                  shouldDataReinitialize={false}
                  thumbnailList={thumbnailDataList}
                />
              )}
            </S.ImageGalleryUl>
          </S.ImageListWrapperStyle>
        </S.ContentWrapperStyle>
        {isUserReview && reviewInfo ? (
          <S.InfoWrapperDiv>
            <S.UserDetailsOuterWrap>
              <S.UserNew />
              <S.UserDetails>
                <S.InfoGalleryTitleWrap>
                  {firstName} {lastName}
                </S.InfoGalleryTitleWrap>
                <S.InfoGallerySubTitleWrap>
                  {dateFormat(submittedAt, 'yyyy, d mmm')}
                </S.InfoGallerySubTitleWrap>
              </S.UserDetails>
            </S.UserDetailsOuterWrap>
            <S.InfoGalleryDescription>{getParsedReview(reviewContent)}</S.InfoGalleryDescription>
          </S.InfoWrapperDiv>
        ) : (
          <></>
        )}
      </S.ContentTextOuterWrap>
    </S.OuterContainerGallery>
  );
};

export default ImageGalleryPopup;
